import { useCallback } from 'react';
import LogRocket from 'logrocket';

const logRocketBrowseFreightRatesEventName = 'BROWSE_FREIGHT_RATES';

export const useTrackBrowseFreightRatesClick = (): (() => void) => {
  return useCallback(() => {
    const environment = process.env.NODE_ENV || 'development';
    LogRocket.track(logRocketBrowseFreightRatesEventName, {
      env: environment,
    });
  }, []);
};
